module.exports = __webpack_public_path__ + "static/media/bgmobile.a90dc076.png";